import axios from 'axios';
import moment from 'moment';
import React, { ReactNode } from 'react';

import type { DepositRegistration } from '@/types/database/depositRegistration';

export const getDetailList = (
  data: DepositRegistration,
  currentPage: 'fromCommunity' | 'fromOutside' | 'received'
) => {
  let list: {
    label: string;
    content: ReactNode;
  }[] = [
    {
      label: '包裹登記時間',
      content: moment(data.packagerRegistrationTime).format(
        'YYYY/MM/DD HH:mm:ss'
      ),
    },
    {
      label: '包裹類型',
      content: data.type,
    },
    {
      label: '包裹名稱',
      content: data.itemName,
    },
    {
      label: data.type === '寄件' ? '寄件人戶號' : '收件人戶號',
      content: data.household,
    },
    {
      label: data.type === '寄件' ? '收件人' : '寄件人',
      content: data.peopleName || '無資料',
    },
    {
      label: '備註',
      content: data.remarks || '無資料',
    },
  ];
  if (currentPage === 'received') {
    list.splice(
      4,
      0,
      {
        label: data.type === '寄件' ? '寄件人' : '收件人',
        content: data.recipient || '無資料',
      },
      {
        label: data.type === '寄件' ? '收件人戶號' : '寄件人戶號',
        content: data.peopleHousehold || '無資料',
      }
    );
  }
  if (['已領取', '已退回'].includes(data.status)) {
    list.push({
      label: '領取時間',
      content: moment(data.receiveTime).format('YYYY/MM/DD HH:mm:ss'),
    });
  }
  list = [
    ...list,
    {
      label: '領取人照片',
      content: data.residentPhoto ? (
        <img src={data.residentPhoto} alt="住戶照片" width={300} height={300} />
      ) : (
        '無資料'
      ),
    },
    {
      label: '領取人簽名',
      content: data.canvas ? (
        <img src={data.canvas} alt="住戶簽名" width={300} />
      ) : (
        '無資料'
      ),
    },
  ];
  return list;
};

export const sendInfo = (item: DepositRegistration) => {
  const query: Record<string, any> = {
    firebaseClass: '寄物管理',
  };

  query.householdNumbers = item.household;

  return axios('/ezcon/api/emitMsgQuery', {
    method: 'POST',
    headers: {
      authorization: window.localStorage['feathers-jwt'],
    },
    data: {
      service: 'message',
      event: 'msg',
      title: '寄物通知',
      // 戶號“您有新的包裹類型請快來領取：時間
      content: `${item.household}您有新的${item.type}請快來領取:${moment(
        item.packagerRegistrationTime
      ).format('YYYY-MM-DD HH:mm:ss')}`,
      type: 'success',
      class: 'deposit',
      duration: 8000,
      redirect: '/ezpro/deposit/depositFrontDesk',
      query,
    },
  });
};
